const authUrls = {
    getTokenUrl: '/v1/api/auth/signin'
}

export {
    authUrls
}